import { Page } from 'layouts/Page';
import { FC } from 'react';
import { PpwrLayout } from 'components/EprPpwr/PpwrLayout';
import { PpwrPackingTypes } from 'components/EprPpwr/PpwrPackingTypes';

export const PpwrPackingProfilePage: FC = () => {
	return (
		<Page title="Packing Profile – EPR/PPWR – EAS Dashboard">
			<PpwrLayout>
				<PpwrPackingTypes />
			</PpwrLayout>
		</Page>
	);
};
